const ITEMS = ["Real Estate Lead Generation", "United States", "Property Marketing", "United Kingdom", "Enquiry Management", "Netherlands", "Client Follow-Up"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t, i) => (
      <span key={t} className="flex items-center">
        <span className={`font-serif-d whitespace-nowrap px-8 text-5xl sm:text-7xl ${i % 2 ? "outline-text italic" : "text-white"}`}>{t}</span>
        <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0 text-[#D4AF37]" fill="currentColor" aria-hidden="true"><path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="overflow-hidden border-y border-[rgba(212,175,55,0.15)] bg-[#0B192C] py-10" data-testid="editorial-marquee" aria-label="Services and markets">
    <div className="marquee-track flex">
      <Row />
      <Row />
    </div>
  </section>
);
